import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
 IconAccount, dlsWhite, IconHome,
} from '@americanexpress/dls-react';
import NavLink from '../Common/NavLink';
import { routes } from '../../constants/paths';

const NavigationHeader = () => {
  const loginData = useSelector((state) => state.getIn(['modules', 'axp-secure-file-express-root', 'userData', 'login'])
  );

  return (
    <div className="fluid dls-bright-blue-bg">
      <div className="container dls-bright-blue-bg pad-0-l">
        <nav className="nav-horizontal nav-header nav-large nav-inverse dls-bright-blue-bg">
          <ul className="nav-menu margin-1-l" role="menubar">
            <li>
              <NavLink pathname={routes.home}>
                <IconHome size="sm" className="icon-hover" theme={dlsWhite} title="Home Icon" />
              </NavLink>
            </li>
          </ul>
          <ul className="nav-menu stack-r pad-1-r">
            <li className="nav-item">
              <NavLink pathname={routes.userDetails}>
                <IconAccount size="sm" className="icon-hover" theme={dlsWhite} title={loginData?.userDetail?.userFullName || 'Account Icon'} />
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

NavigationHeader.propTypes = {
  notificationData: PropTypes.shape({
    unReadNotifications: PropTypes.shape({
      count: PropTypes.number.isRequired,
      notifications: PropTypes.arrayOf(
        PropTypes.shape({
          notificationId: PropTypes.number.isRequired,
          notificationMessage: PropTypes.string.isRequired,
          notificationDate: PropTypes.string.isRequired,
        })
      ),
    }),
    readNotifications: PropTypes.shape({
      count: PropTypes.number.isRequired,
      notifications: PropTypes.arrayOf(
        PropTypes.shape({
          notificationId: PropTypes.number.isRequired,
          notificationMessage: PropTypes.string.isRequired,
          notificationDate: PropTypes.string.isRequired,
        })
      ),
    }),
  }),
};

export default NavigationHeader;
